export default "__VITE_ASSET__CaDqUXUR__"